<template>
  <div class="contract-peform-detail">
    <common-header />
    <div class="width-1260">
      <el-breadcrumb>
        <el-breadcrumb-item :to="{ path: '/' }"
          >平方区域联采</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/mineProject' }"
          >我的联采项目</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/jointPlan' }"
          >联采方案列表</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/jointPlan/detail', params: '123' }"
          >查看联采方案</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ renderDom.breadcrumb }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="white-container">
        <div class="title">
          {{ renderDom.title }}
        </div>
        <!-- 方案状态 -->
        <div class="process-container" v-if="routeParams.type !== '1'">
          <template
            v-for="(item, index) in detailData.agreeProgressList"
            :key="index"
          >
            <div v-if="item.isShow && processVisible(item)">
              <div
                class="process-item d-flex-all-center"
                :class="item.operationTime ? 'process-item-active' : ''"
                @click="() => setCurrentProcess(item, index)"
              >
                <div class="inner d-flex-all-center">
                  <div>
                    {{ item.progressName }}
                  </div>
                </div>
              </div>
              <div class="font-12 time-container font-c-175eff">
                {{ item.operationTime }}
              </div>
            </div>
          </template>
        </div>
        <!-- 方案详情 -->
        <el-form
          ref="formRef"
          :rules="userRole === userRoleType.purchaser && renderDom.formRules"
          :model="detailData"
        >
          <div class="form-flex">
            <div v-for="(item, cIndex) in renderDom.contractList" :key="cIndex">
              <el-form-item
                :label="item.name"
                v-if="item.key === 'remarks'"
                label-width="80px"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  :style="{ width: item.width }"
                  :readonly="disabled || !item.editable"
                  v-model="detailData[item.key]"
                />
              </el-form-item>
              <el-form-item
                :label="item.name"
                v-else-if="item.type === 'attachment'"
                :prop="item.key"
                label-width="80px"
              >
                <div class="width-455px">
                  <template v-if="Array.isArray(detailData[item.key])">
                    <div
                      v-if="
                        routeParams.type === '4' &&
                        userRole === userRoleType.purchaser
                      "
                    >
                      <el-upload
                        v-model:file-list="detailData[item.key]"
                        :action="projectDocUploadUrl"
                        with-credentials
                        :on-preview="priviewFile"
                        :disabled="disabled"
                        accept=".jpg, .PNG, .png, .jpeg, .pdf, .xls, .xlsx"
                        :on-success="
                          (res, file, files) =>
                            uploadSuccess(res, file, files, item.key)
                        "
                        :on-remove="(file, files) => removeFile(files)"
                        multiple
                        name="files"
                        :data="{ fileType: item.fileType }"
                      >
                        <el-button
                          v-if="
                            routeParams.type === '4' &&
                            userRole === userRoleType.purchaser
                          "
                          :disabled="disabled"
                          type="primary"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </div>
                    <!-- <div
                      v-for="(file, fIndex) in detailData[item.key]"
                      :key="fIndex"
                    >
                      <a class="width-455" :href="file.path" target="_blank"
                        >{{ file.name }}
                      </a>
                    </div> -->
                  </template>
                  <div class="width-455" v-else>
                    <el-upload
                      ref="upload"
                      v-model:file-list="detailData[item.key + 'List']"
                      :action="projectDocUploadUrl"
                      with-credentials
                      :on-preview="priviewFile"
                      accept=".jpg, .PNG, .png, .jpeg, .pdf, .xls, .xlsx"
                      :on-success="
                        (res, file, files) =>
                          uploadSuccess(res, file, files, item.key + 'List')
                      "
                      :on-remove="
                        (file, files) => removeFile(files, item.key + 'List')
                      "
                      name="files"
                      :data="{ fileType: item.fileType }"
                    >
                      <el-button
                        v-if="
                          routeParams.type === '4' &&
                          userRole === userRoleType.purchaser
                        "
                        :disabled="disabled"
                        type="primary"
                        >点击上传</el-button
                      >
                    </el-upload>
                    <!-- <a :href="detailData[item.key]?.path" target="_blank"
                      >{{ detailData[item.key]?.name }}
                    </a> -->
                  </div>
                </div>
              </el-form-item>
              <el-form-item
                :label="item.name"
                v-else-if="item.type === 'radio'"
                :prop="item.key"
                :label-width="item.width ? item.width : '80px'"
              >
                <el-radio-group
                  v-model="detailData[item.key]"
                  :style="{ width: '455px' }"
                  :disabled="disabled"
                >
                  <el-radio :label="1">固定价</el-radio>
                  <el-radio :label="2">浮动价</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="item.name"
                v-else-if="item.type === 'date'"
                :label-width="item.width ? item.width : '80px'"
              >
                <el-date-picker
                  style="width: 455px"
                  format="YYYY/MM/DD"
                  value-format="YYYY-MM-DD"
                  :disabled="disabled"
                  clearable
                  v-model="detailData[item.key]"
                  type="date"
                />
              </el-form-item>
              <el-form-item
                :label="item.name"
                :prop="item.key"
                v-else
                :label-width="item.width ? item.width : '80px'"
              >
                <el-input-number
                  class="text-align-start"
                  :disabled="!item.editable || disabled"
                  v-if="item.type === 'number'"
                  v-model="detailData[item.key]"
                  :style="{ width: '455px' }"
                  :min="0"
                  clearable
                  :controls="false"
                />
                <el-input
                  v-else
                  :style="{ width: '455px' }"
                  :readonly="!item.editable || disabled"
                  v-model="detailData[item.key]"
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
        <!-- 方案表格 -->
        <div
          class="table-container"
          v-for="(columnItem, index) in renderDom.columns"
          :key="index"
        >
          <div class="s-title">
            <div class="blue-common-title">{{ columnItem.columnsName }}</div>
            <div class="btn-container">
              <el-button
                v-if="columnItem.exportBtn"
                @click="handleDownloadFile"
              >
                <el-icon class="icon icon-xiazai3"></el-icon
                >导出材料清单</el-button
              >
              <el-upload
                v-if="
                  columnItem.uploadBtn &&
                  userRole === userRoleType.purchaser &&
                  (routeParams.type === '3' || routeParams.type === '4') &&
                  !disabled
                "
                class="upload-btn"
                accept=".xls, .xlsx"
                :action="columnItem.uploadObject.action"
                :on-success="uploadMaterialFileSuccess"
                :on-progress="uploadMaterialFileProgress"
                :with-credentials="true"
                :show-file-list="false"
                :data="{
                  [columnItem.uploadObject.key]: routeParams.id,
                }"
              >
                <el-button>
                  <el-icon class="icon icon-shangchuan2"></el-icon
                  >导入材料清单</el-button
                >
              </el-upload>
            </div>
          </div>
          <el-form
            ref="editTabeRef"
            :model="editTableData"
            :rules="columnItem.formRules"
          >
            <el-table
              :border="parentBorder"
              :header-cell-style="{
                backgroundColor: '#F2F3F5',
                color: '#1D2129',
              }"
              :row-style="{ height: '60px' }"
              tooltip-effect="light"
              :data="detailData[columnItem.key]"
            >
              <template
                v-for="(item, index) in columnItem.columns"
                :key="index"
              >
                <el-table-column
                  v-if="item.key === 'number'"
                  :prop="item.key"
                  :label="item.name"
                  align="center"
                  :width="80"
                >
                  <template #default="scope">
                    {{ scope.row.number ? scope.row.number : scope.$index }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-else-if="item.key === 'acceptStatus'"
                  :prop="item.key"
                  :label="item.name"
                  align="center"
                  :min-width="120"
                >
                  <template #default="scope">
                    {{ acceptStatusDic[scope.row.acceptStatus] }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-else-if="item.key === 'operate'"
                  :prop="item.key"
                  fixed="right"
                  label="操作"
                  align="center"
                  show-overflow-tooltip
                  :min-width="120"
                >
                  <template #default="scope">
                    <template
                      v-if="
                        scope.row.number !== '合计' && userRole === '采购商'
                      "
                    >
                      <template v-if="editTableIndex === scope.$index">
                        <el-button :link="true" @click="handleSaveTableEditRow"
                          >保存</el-button
                        >
                        |
                        <el-button
                          class="margin-left-0"
                          :link="true"
                          @click="cancelEditRow"
                          >取消</el-button
                        >
                      </template>
                      <template v-else>
                        <el-button
                          :link="true"
                          :disabled="disabled"
                          @click="setTableEditRow(scope.$index, scope.row)"
                          >编辑</el-button
                        >
                        <template v-if="routeParams.type === '4'">
                          |<el-button
                            class="margin-left-0"
                            :link="true"
                            :disabled="disabled"
                            @click="deleteSettlementMaterial(scope.row.id)"
                            >删除</el-button
                          >
                        </template>
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  v-else
                  :prop="item.key"
                  :label="item.name"
                  align="center"
                  show-overflow-tooltip
                  :min-width="120"
                >
                  <template #default="scope">
                    <el-form-item
                      v-if="
                        (item.key === 'acceptTaxPrice' ||
                          item.key === 'acceptCount' ||
                          item.key === 'realityPrice') &&
                        editTableIndex === scope.$index &&
                        routeParams.type === '3'
                      "
                      :key="index"
                      :prop="item.key"
                    >
                      <span v-if="item.key === 'taxTotalPrice'">{{
                        editTableData[item.key]
                      }}</span>
                      <el-input-number
                        v-else-if="item.type === 'number'"
                        v-model="editTableData[item.key]"
                        :min="0"
                        :controls="false"
                      />
                      <el-input v-else v-model="editTableData[item.key]" />
                    </el-form-item>
                    <el-form-item
                      v-if="
                        columnItem.columns.findIndex(
                          (col) => col.key === item.key
                        ) &&
                        editTableIndex === scope.$index &&
                        routeParams.type === '4'
                      "
                      :key="index"
                      :prop="item.key"
                    >
                      <span v-if="item.key === 'taxTotalPrice'">{{
                        editTableData[item.key]
                      }}</span>
                      <el-input-number
                        v-else-if="item.type === 'number'"
                        v-model="editTableData[item.key]"
                        :min="0"
                        :controls="false"
                      />
                      <el-input v-else v-model="editTableData[item.key]" />
                    </el-form-item>
                    <span v-else>
                      {{ scope.row[item.key] }}
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </el-form>
        </div>
        <div
          class="text-align-center"
          v-if="
            routeParams.type === '4' &&
            userRole === userRoleType.purchaser &&
            detailData.settlementStatus < 4
          "
        >
          <el-button @click="goListPage">返回</el-button>
          <el-button type="primary" @click="handleCommitData">保存</el-button>
        </div>
      </div>
    </div>
    <common-footer />
    <el-dialog
      :title="currentProcess.title"
      width="900px"
      v-model="processModal"
      destroy-on-close
      :close-on-click-modal="false"
      @close="closeModal"
    >
      <!-- 编辑进程 -->
      <div
        v-if="Object.keys(currentEditProcess).length"
        class="edit-process-modal"
      >
        <el-form
          :model="currentEditProcessData"
          :rules="currentEditProcess.rules"
          ref="currentEditProcessRef"
          label-width="150px"
        >
          <el-form-item
            v-for="(item, index) in currentEditProcess.modalContent"
            :label="item.label"
            :prop="item.key"
            :key="index"
          >
            <el-input
              v-if="item.type === 'input'"
              class="width-455px"
              v-model="currentEditProcessData[item.key]"
            ></el-input>
            <el-radio-group
              v-if="item.type === 'radio'"
              class="width-455px"
              v-model="currentEditProcessData[item.key]"
            >
              <el-radio :label="1">固定价</el-radio>
              <el-radio :label="2">浮动价</el-radio>
            </el-radio-group>
            <el-date-picker
              v-if="item.type === 'date'"
              style="width: 455px"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
              v-model="currentEditProcessData[item.key]"
              type="date"
            />
            <el-upload
              v-if="item.type === 'upload'"
              :action="projectDocUploadUrl"
              with-credentials
              accept=".jpg, .PNG, .png, .jpeg, .pdf, .xls, .xlsx"
              :on-success="(res, file, files) => uploadProgressFile(files, res)"
              :on-remove="(file, files) => removeProgressFile(files)"
              multiple
              name="files"
              :data="{ fileType: 'ACCEPT_FORM' }"
            >
              <el-button type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="item.type === 'dateRange'" class="width-455px">
              <el-date-picker
                format="YYYY/MM/DD"
                value-format="YYYY-MM-DD"
                v-model="currentEditProcessData[item.key]"
                type="daterange"
                @change="handleChangeDate"
              />
            </div>
          </el-form-item>
          <div class="text-align-center margin-t-30">
            <el-button @click="closeModal">取消</el-button>
            <el-button
              type="primary"
              @click="commitEditProcess(currentEditProcessRef)"
              >确认</el-button
            >
          </div>
        </el-form>
      </div>
      <!-- 查看进程 -->
      <div v-else class="process-modal">
        <div
          v-for="(item, index) in currentProcess.data"
          :key="index"
          class="block-item"
        >
          <div
            v-for="(processKey, pIndex) in Object.keys(item)"
            :key="pIndex"
            class="message-container"
          >
            <div class="label">{{ processKey }}</div>
            <template v-if="Array.isArray(item[processKey])">
              <div
                v-if="processKey === '生产周期'"
                class="value-break margin-b-16"
              >
                {{ item[processKey].join(" - ") }}
              </div>
              <div v-else class="value-break">
                <div
                  v-for="(label, lIndex) in item[processKey]"
                  :key="lIndex"
                  class="break-word margin-b-16"
                >
                  <a :href="Object.values(label)[0]" target="_blank">
                    {{ Object.keys(label)[0] }}
                  </a>
                </div>
              </div>
            </template>
            <div v-else class="margin-b-16">{{ item[processKey] }}</div>
          </div>
        </div>
        <div class="text-align-center margin-t-30">
          <el-button type="primary" @click="closeModal">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
module.exports = require("./index");
</script>
<style lang="scss">
@import "./index.scss";
</style>
